import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TeamUser } from '../../interfaces/team';
import { PersonalUser } from '../../interfaces/account';

export interface UserAccess {
  currentAccount: TeamUser | PersonalUser | null;
  personalAccount: PersonalUser | null;
  currentTeamAccount: TeamUser | null;

  isOwner: boolean;
  isAdmin: boolean;
  isMember: boolean;
  hasOwnerAccess: boolean;
  hasAdminAccess: boolean;
  hasMemberAccess: boolean;
  isTeamUser: boolean;
  isPersonalUser: boolean;
}

const initialState: UserAccess = {
  currentAccount: null,
  personalAccount: null,
  currentTeamAccount: null,
  isOwner: false,
  isAdmin: false,
  isMember: false,
  hasOwnerAccess: false,
  hasAdminAccess: false,
  hasMemberAccess: false,
  isTeamUser: false,
  isPersonalUser: false,
};

const accessSlice = createSlice({
  name: 'access',
  initialState,
  reducers: {
    setAccess: (state, action: PayloadAction<UserAccess>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setAccess } = accessSlice.actions;
export default accessSlice.reducer;
